import { Box, Button, HStack, IconButton, Text } from '@chakra-ui/react'
import { FiX } from 'react-icons/fi'
import type { ReplanNudge as Nudge } from '../../../hooks/useReplanNudge'
import { NUDGE_COPY } from './replanNudgeCopy'

/** [A3 §6] Absolute banner in the map area, above the distance pill and recentre button (the dock sits below the map, so no safe-area padding is needed). Never reorders by itself. */
export function ReplanNudge({ nudge, onReplan, onDismiss }: {
  nudge: Nudge; onReplan: () => void; onDismiss: () => void
}) {
  return (
    <Box position="absolute" left={3} right={3} bottom={16} zIndex={3} pointerEvents="none">
      <div role="status" aria-live="polite">
        {nudge && (
          <HStack bg="surface" borderRadius="md" shadow="md" p={2} pl={3} gap={2} pointerEvents="auto">
            <Text flex={1} fontSize="sm" color="fg">{NUDGE_COPY[nudge]}</Text>
            <Button minH="44px" size="sm" colorPalette="brand" onClick={onReplan}>Re-plan</Button>
            <IconButton aria-label="Dismiss" minW="44px" minH="44px" variant="ghost" onClick={onDismiss}><FiX /></IconButton>
          </HStack>
        )}
      </div>
    </Box>
  )
}
